import { MailThreadId } from 'types';

export const SUBSCRIBE_TO_NOTIFICATIONS = '/api/v1/mail/for-parent/notification/subscribe';
export const UNREAD_MAIL_THREADS = '/api/v1/mail/for-parent/notification/unread-threads';
export const MAIL_THREADS = '/api/v1/mail/for-parent/threads';
export const MAIL_THREAD = (mailThreadId: MailThreadId) =>
    `/api/v1/mail/for-parent/threads/${mailThreadId}`;
export const MAIL_THREAD_RECEIVERS = '/api/v1/mail/for-parent/receivers';
export const MAIL_THREAD_MESSAGES = (mailThreadId: MailThreadId) =>
    `/api/v1/mail/for-parent/threads/${mailThreadId}/messages`;
export const REPLY_MAIL_THREAD = (mailThreadId: MailThreadId) =>
    `/api/v1/mail/for-parent/threads/${mailThreadId}/reply-thread`;
